import React from 'react';

import request from 'superagent';
import throwApireqDebugError from '@helpers/throwApireqDebugError';

import PAGES_TYPE from 'shared-constants/src/pagesType';

export const LS_CERCACASA_STARTPAGE = 'csa__cercacasa__entrypoint';

export const getMainLocation = (locations) => {
  if (!locations.length) {
    return {
      name: 'scegli dove',
    };
  }
  const [loc] = locations;
  return {
    name: loc.name,
    type: loc.parent.province.name === loc.name ? ' (comune)' : '',
  };
};

export const createSteps = (configuration) => {
  const steps = {};
  Object.keys(configuration).forEach((step) => {
    const Component = configuration[step].component;
    steps[step] = x => (
      <Component
        key={`step-${step}`}
        stepProps={x}
      />
    );
  });
  return steps;
};

export const smoothScroll = (coords, scroller) => {
  const diff = (coords - scroller.scrollTop) / 4.5;
  if (Math.abs(diff) > 1) {
    scroller.scrollTo(0, (scroller.scrollTop + diff));
    clearTimeout(window.TO);
    window.TO = setTimeout(smoothScroll, 30, coords, scroller);
  } else {
    scroller.scrollTo(0, coords);
  }
};

export const wizardStateToQObject = (wizardFilters, locations) => {
  const {
    tr, propertyTypeGroup, propertyTypes, rooms, bathrooms, price, priceMin, priceMax,
    parkingSpaces, balconyTerrace, garden, lift, hasReception, hasAC, level, nearby,
  } = wizardFilters || {};
  const qObject = {};
  if (tr) qObject.tr = tr;
  if (propertyTypeGroup) qObject.propertyTypeGroup = propertyTypeGroup;
  if (propertyTypes && propertyTypes.length) qObject.propertyTypes = propertyTypes;
  if (rooms != null) qObject.rooms = `${rooms}-`;
  if (bathrooms != null) qObject.bathrooms = `${bathrooms}-`;
  const prMin = (price && price.min != null) ? price.min : (priceMin != null ? priceMin : '');
  const prMax = (price && price.max != null) ? price.max : (priceMax != null ? priceMax : '');
  if (prMin || prMax) qObject.price = `${prMin}-${prMax}`;
  if (locations && locations.length) qObject.q = locations.map((l) => l.hkey).filter(Boolean);
  if (parkingSpaces != null && parkingSpaces !== 'all') qObject.parkingSpaces = parkingSpaces;
  if (balconyTerrace && balconyTerrace[0] !== 'all') qObject.balconyTerrace = balconyTerrace;
  if (garden && garden[0] !== 'all') qObject.garden = garden;
  if (lift != null && lift !== 'all') qObject.lift = lift;
  if (hasReception) qObject.hasReception = hasReception;
  if (hasAC) qObject.hasAC = hasAC;
  if (level != null && level !== 'all') {
    if (level === 'piano terra') qObject.level = 0;
    else if (level === 'intermedio') qObject.level = 999;
    else if (level === 'ultimo') qObject.level = 1000;
    else if (!isNaN(Number(level))) qObject.level = Number(level);
  }
  qObject.isAuction = false;
  if (nearby && nearby.location) {
    qObject.nearby = {
      point: [nearby.location.lat, nearby.location.lon],
      travel_mode: nearby.travel_mode,
      travel_time: nearby.travel_time,
    };
  }
  return qObject;
};

export const computeAPIReq = async ({
  locations,
  filters,
  apireqParams,
}) => {
  let qObject;
  try {
    qObject = wizardStateToQObject(filters, locations);
    const proxy = await request.post('/portal-srp/api/v1/apireq')
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .withCredentials()
      .send({
        qObject,
        apireqParams,
        pageType: PAGES_TYPE.SRP,
      });
    const { body: { apireq, uri, queryFilters } } = proxy;
    apireq.size = 0;
    delete apireq.query.seo;
    apireq.query[0].modifiers = {
      with_surroundings: false,
      autoexpand_location_polygon: false,
      with_breadcrumb: false,
      with_filters: false,
      with_georeach: false,
      with_poi: false,
    };
    return {
      apireq,
      uri,
      queryFilters,
      domain: (apireqParams && apireqParams.domain) || 'casa.it',
      locale: (apireqParams && apireqParams.locale) || 'it',
    };
  } catch (error) {
    throwApireqDebugError('CercaCasa', error, locations, qObject);
  }
};
